import { FC } from 'react';
import { isFilled } from '@prismicio/client';
import type { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';

interface DescriptionProps {
  field?: RichTextField;
  /**
   * Tailwind classes for the wrapper around the rich text. Variants pass
   * their own typography / color so each stays independent — the shell only
   * owns the paragraph serializer (16/18px rhythm with a shared `mb-3` gap).
   */
  className?: string;
}

/**
 * Shared hero description renderer. The paragraph serializer is identical
 * across variants; only the wrapper's font color / weight differ, which the
 * variant supplies through `className`.
 */
const Description: FC<DescriptionProps> = ({ field, className }) => {
  if (!isFilled.richText(field)) {
    return null;
  }
  return (
    <div className={className}>
      <PrismicRichText
        field={field}
        components={{
          paragraph: ({ children }) => (
            <p className="mb-3 last:mb-0">{children}</p>
          ),
        }}
      />
    </div>
  );
};

export default Description;
